import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
import { Guarantee } from './Guarantee';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="offer" ref={ref} className="w-full bg-gradient-to-br from-rose/10 to-gold/10 py-6 md:py-10 px-6" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-180">
          <h2 id="offer-heading" className="font-serif text-3xl md:text-4xl font-bold text-brown mb-4 scroll-mt-8" data-id="element-181">
            Tu Inversión en el Milagro
          </h2>

          <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border-2 border-gold/30 mb-6" data-id="element-182">
            <p className="font-sans text-lg text-brown/90 leading-relaxed mb-6" data-id="element-183">
              Hoy puedes acceder al sistema completo "El Código del Vientre",
              incluyendo el eBook, las plantillas de trabajo y los audios de
              meditación sistémica.
            </p>

            <div id="offer-price" className="flex items-center justify-center gap-4 mb-6 scroll-mt-24" data-id="element-184">
              <div className="text-center" data-id="element-185">
                <div className="flex flex-col items-center gap-2 mb-3" data-id="element-186">
                  <div className="flex items-center gap-3" data-id="element-187">
                    <span className="font-serif text-3xl text-brown/40 line-through" data-id="element-188">
                      $27
                    </span>
                    <span className="font-sans text-lg text-brown/70" data-id="element-189">USD</span>
                  </div>
                  <p className="font-sans text-lg text-brown/80 font-medium" data-id="element-190">
                    Hoy solo
                  </p>
                  <div className="flex items-baseline gap-2" data-id="element-191">
                    <span className="font-sans text-6xl md:text-8xl font-black text-rose whitespace-nowrap tracking-tight" data-id="element-192">
                      $14.00
                    </span>
                    <span className="font-sans text-xl text-brown/70 font-medium" data-id="element-193">
                      USD
                    </span>
                  </div>
                </div>
                <div className="font-sans text-base text-brown/60" data-id="element-194">
                  Pago Único
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center gap-2 mb-6" data-id="element-195">
              <div className="flex items-center gap-2 text-brown/70" data-id="element-196">
                <CheckIcon className="w-5 h-5 text-rose" data-id="element-197" />
                <span className="font-sans text-base" data-id="element-198">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2 text-brown/70" data-id="element-199">
                <CheckIcon className="w-5 h-5 text-rose" data-id="element-200" />
                <span className="font-sans text-base" data-id="element-201">
                  Todos los materiales incluidos
                </span>
              </div>
              <div className="flex items-center gap-2 text-brown/70" data-id="element-202">
                <CheckIcon className="w-5 h-5 text-rose" data-id="element-203" />
                <span className="font-sans text-base" data-id="element-204">Tuyo para siempre</span>
              </div>
            </div>

            <motion.button id="offer-cta" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => {
            trackAddToCart();
            window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
          }} className="bg-gradient-to-r from-rose to-gold text-white font-sans font-bold text-xl px-16 py-6 rounded-full shadow-2xl hover:shadow-xl transition-shadow w-full md:w-auto cursor-pointer" data-id="element-205">
              Quiero Sanar Mi Linaje y Recibir a Mi Hijo
            </motion.button>

            <p className="font-sans text-sm text-brown/60 mt-6" data-id="element-206">
              Acceso inmediato y discreto para comenzar esta misma noche.
            </p>

            <Guarantee data-id="element-207" />
          </div>
        </motion.div>
      </div>
    </section>;
}